import styled from 'styled-components'
import { theme } from 'utils/theme'

export const ContentContainer = styled.div``

export const ImageContainer = styled.div`
  margin-left: -40px;
  margin-right: -40px;
  height: 288px;
  background-image: url(${props => props.image});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`

export const DetailsContainer = styled.div`
  position: relative;
  width: 556px;
  height: 258px;
  background: ${theme.colors.black};
  bottom: 14px;
  right: 40px;
  overflow: auto;
`

export const Info = styled.div`
  padding: 16px;
`

export const Title = styled.h1`
  font-family: Bison;
  font-weight: 700;
  color: ${theme.colors.lightGold};
  font-size: 50px;
  line-height: 54px;
  margin-bottom: 20px;
`

export const Description = styled.p`
  font-family: AzoSans;
  font-weight: 600;
  font-size: 22px;
  line-height: 25px;
  margin-bottom: 0;
  ${props => props.isEvent && 'text-transform: uppercase'};
`

export const VideoBg = styled.div`
  background: ${theme.colors.black};
  width: 100%;
  height: 100%;
`
